<app-spinner-overlay [showSpinner]="isSendingFeedback">
    <div class="container col-sm-10 col-md-8 col-lg-6 col-xl-5 my-2">
        <form
            [formGroup]="feedbackForm"
            class="vstack gap-3"
        >
            <ng-template #ratingButton let-value="value" let-btnId="btnId" let-iconUrl="iconUrl" let-iconAlt="iconAlt" let-bgColor="bgColor" let-textColor="textColor">
                <div class="d-flex flex-fill" style="min-width: 0;">
                    <input
                        type="radio"
                        class="btn-check"
                        formControlName="rating"
                        [id]="btnId"
                        autocomplete="off"
                        [value]="value"
                    >
                    <label class="btn border-0 vstack gap-1 gap-sm-2 align-items-center" [attr.for]="btnId" style="padding: 0.25rem; font-size: clamp(0.75rem, 2.5vw, 1rem);">
                        <div class="position-relative">
                            <div class="position-absolute top-50 start-50 translate-middle rounded-circle opacity-25" 
                                 [ngClass]="bgColor"
                                 style="width: clamp(50px, 15vw, 60px); height: clamp(50px, 15vw, 60px); z-index: 0;"
                                 [style.display]="feedbackForm.get('rating')?.value === value ? 'block' : 'none'">
                            </div>
                            <img
                                [ngSrc]="iconUrl"
                                width="44"
                                height="44"
                                [alt]="iconAlt"
                                class="position-relative"
                                style="z-index: 1; width: clamp(38px, 10vw, 44px); height: clamp(38px, 10vw, 44px);"
                            >
                        </div>
                        <span [ngClass]="textColor" [class.fw-semibold]="feedbackForm.get('rating')?.value === value">{{ value | ratingName }}</span>
                    </label>
                </div>
            </ng-template>

            <h5 class="fw-semibold text-muted m-0 align-self-center">
                {{ booking.venueName }}
            </h5>
            <h5 class="fw-semibold m-0 align-self-center">
                Rate Your Experience
            </h5>
            <div class="vstack">
                <div class="rounded-top bg-light p-3">
                    <div class="vstack gap-2">
                        <div class="vstack gap-3">
                            <span>
                                @if (booking.bookingName.length > 0) {
                                    Hi {{ booking.bookingName }},
                                } @else {
                                    Hi there,
                                }
                            </span>
                            <span>
                                Thank you for visiting
                                {{ booking.venueName}}
                                on
                                <span class="fw-semibold">
                                    {{ booking.dateTime | date : 'shortDate' }}
                                </span>
                                at
                                <span class="fw-semibold">
                                    {{ booking.dateTime | date : 'shortTime' }}
                                </span>.
                            </span>
                        </div>
                        <span class="text-muted">
                            We'd love it if you'd take just a moment to tell us about your experience with us.
                        </span>
                    </div>
                </div>
                <div class="rounded-bottom border-start border-end border-bottom border-light-subtle p-3">
                    <div class="vstack gap-3">
                        <div class="vstack gap-1">
                            <div class="hstack gap-2 align-self-center justify-content-center align-items-center">
                                <h5>
                                How did we do?
                                </h5>
                            </div>
                            <div class="vstack gap-2">
                                <div
                                    class="pt-2 d-flex flex-row flex-row-reverse justify-content-around px-2 px-md-3 px-lg-5"
                                    role="group"
                                    style="max-width: 100%; overflow: hidden;"
                                >
                                    <ng-container *ngTemplateOutlet="ratingButton; context: {
                                        value: 5,
                                        btnId: 'btn-excellent',
                                        iconUrl: 'https://cdn.tablesense.com/feedback/great.png',
                                        iconAlt: 'Great',
                                        bgColor: 'bg-primary',
                                        textColor: 'text-primary'
                                    }"></ng-container>
                                    <ng-container *ngTemplateOutlet="ratingButton; context: {
                                        value: 4,
                                        btnId: 'btn-good',
                                        iconUrl: 'https://cdn.tablesense.com/feedback/good.png',
                                        iconAlt: 'Good',
                                        bgColor: 'bg-success',
                                        textColor: 'text-success'
                                    }"></ng-container>
                                    <ng-container *ngTemplateOutlet="ratingButton; context: {
                                        value: 3,
                                        btnId: 'btn-fair',
                                        iconUrl: 'https://cdn.tablesense.com/feedback/ok.png',
                                        iconAlt: 'Okay',
                                        bgColor: 'bg-secondary',
                                        textColor: 'text-secondary'
                                    }"></ng-container>
                                    <ng-container *ngTemplateOutlet="ratingButton; context: {
                                        value: 2,
                                        btnId: 'btn-poor',
                                        iconUrl: 'https://cdn.tablesense.com/feedback/poor.png',
                                        iconAlt: 'Poor',
                                        bgColor: 'bg-warning',
                                        textColor: 'text-warning-emphasis'
                                    }"></ng-container>
                                    <ng-container *ngTemplateOutlet="ratingButton; context: {
                                        value: 1,
                                        btnId: 'btn-very-poor',
                                        iconUrl: 'https://cdn.tablesense.com/feedback/bad.png',
                                        iconAlt: 'Very Poor',
                                        bgColor: 'bg-danger',
                                        textColor: 'text-danger'
                                    }"></ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="vstack gap-2">
                            <label
                                class="form-label"
                            >
                                How would you rate the following?
                            </label>
                            <!-- Food rating -->
                            <div class="row">
                                <div class="col-2 col-sm-3">
                                    Food
                                </div>
                                <div class="col-10 col-sm-9 hstack gap-1 gap-sm-3" role="group">
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="foodRating1"
                                        formControlName="food"
                                        autocomplete="off"
                                        [value]="1"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="foodRating1"
                                    >
                                        1
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="foodRating2"
                                        formControlName="food"
                                        autocomplete="off"
                                        [value]="2"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="foodRating2"
                                    >
                                        2
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="foodRating3"
                                        formControlName="food"
                                        autocomplete="off"
                                        [value]="3"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="foodRating3"
                                    >
                                        3
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="foodRating4"
                                        formControlName="food"
                                        autocomplete="off"
                                        [value]="4"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="foodRating4"
                                    >
                                        4
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="foodRating5"
                                        formControlName="food"
                                        autocomplete="off"
                                        [value]="5"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="foodRating5"
                                    >
                                        5
                                    </label>
                                </div>
                            </div>

                            <!-- Service rating -->
                            <div class="row">
                                <div class="col-2 col-sm-3">
                                    Service
                                </div>
                                <div class="col-10 col-sm-9 hstack gap-1 gap-sm-3" role="group">
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="serviceRating1"
                                        formControlName="service"
                                        autocomplete="off"
                                        [value]="1"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="serviceRating1"
                                    >
                                        1
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="serviceRating2"
                                        formControlName="service"
                                        autocomplete="off"
                                        [value]="2"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="serviceRating2"
                                    >
                                        2
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="serviceRating3"
                                        formControlName="service"
                                        autocomplete="off"
                                        [value]="3"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="serviceRating3"
                                    >
                                        3
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="serviceRating4"
                                        formControlName="service"
                                        autocomplete="off"
                                        [value]="4"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="serviceRating4"
                                    >
                                        4
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="serviceRating5"
                                        formControlName="service"
                                        autocomplete="off"
                                        [value]="5"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="serviceRating5"
                                    >
                                        5
                                    </label>
                                </div>
                            </div>

                            <!-- Atmosphere rating -->
                            <div class="row">
                                <div class="col-2 col-sm-3">
                                    Atmosphere
                                </div>
                                <div class="col-10 col-sm-9 hstack gap-1 gap-sm-3" role="group">
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="atmosphereRating1"
                                        formControlName="atmosphere"
                                        autocomplete="off"
                                        [value]="1"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="atmosphereRating1"
                                    >
                                        1
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="atmosphereRating2"
                                        formControlName="atmosphere"
                                        autocomplete="off"
                                        [value]="2"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="atmosphereRating2"
                                    >
                                        2
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="atmosphereRating3"
                                        formControlName="atmosphere"
                                        autocomplete="off"
                                        [value]="3"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="atmosphereRating3"
                                    >
                                        3
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="atmosphereRating4"
                                        formControlName="atmosphere"
                                        autocomplete="off"
                                        [value]="4"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="atmosphereRating4"
                                    >
                                        4
                                    </label>
                                    <input
                                        type="radio"
                                        class="btn-check"
                                        id="atmosphereRating5"
                                        formControlName="atmosphere"
                                        autocomplete="off"
                                        [value]="5"
                                    >
                                    <label
                                        class="btn btn-light flex-fill"
                                        for="atmosphereRating5"
                                    >
                                        5
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label for="comment" class="form-label">Leave us a comment (optional)</label>
                            <textarea
                                class="form-control"
                                placeholder="Tells us more about your experience"
                                id="comment"
                                formControlName="comment"
                                rows="3"
                            >
                            </textarea>
                        </div>
                    </div>
                    <div class="mt-2 row justify-content-end">
                        <div class="col-auto">
                            <button
                                type="submit"
                                class="btn btn-primary"
                                [disabled]="!feedbackForm.valid"
                                (click)="onSubmitFeedback()"
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</app-spinner-overlay>
